<template>
  <div :id="id" :echartTitle="echartTitle" style="height: 100%"></div>
</template>

<script>

import EmCommonApi from "@/mixin/em/common/api";
import * as echarts from 'echarts';

export default {
  name: "echartLeft_2",
  mixins: [EmCommonApi],
  props: {
    id: String,
    echartTitle: String,
  },
  data() {
    return {
      chart: {},
      dataValueX :[],
      dataValueY_l :[],
      productData: [[],[]],  // 两个数组是因为有两条线
      option: {},
      fresh: {},
    }
  },
  watch:{
    //监听year的变化，这个year是父组件传递的参数，利用watch监听再刷新当前子组件
    // year(newValue,oldValue){
    //   console.log("旧年份：" + oldValue + "父组件传递的新年份：" + newValue)
    //   this.getRemoteData();
  },
  created() {
    //初始化数据
    //测试数据
    // this.dataValueX = ["-01#","-02#","-03#","-04#","-05#","-06#"];   //x
    // for(let i = 0;i < 6;i++){
    //   this.dataValueY_l.push(70);
    // }
    this.getRemoteData()
  },
  mounted() {
    //window.addEventListener('resize', this.chart.resize, false);
    //这里可以屏蔽了，用watch生命周期监控year就可以触发了
    //this.getRemoteData();

    //定时轮巡查询
    this.fresh = setInterval(() => {
      this.getRemoteData();
      window.addEventListener('resize', this.chart.resize, false)
    },  10000);

  },
  beforeDestroy() {
    clearInterval(this.fresh);
    //window.removeEventListener('resize', this.chart.resize, false)
  },
  methods: {
    getRemoteData() {
      //主电机温度
      let _url = this.$_emApiMixin_entityBaseApi("emSicEafmREocEmrec") + "/getMainMotorTemperature";
      // console.log("励磁电流url：")
      // console.log(_url)
      this.$_emApiMixin_get(_url,)
          .then((res) => {
            console.log("主电机励磁电流：")
            console.log(res)
            //console.log(res[0][0])

            //每次循环提取前要清空，否则会累加push
            this.productData[0] = [];
            this.productData[1] = [];
            this.dataValueX = ["-01#","-02#","-03#","-04#","-05#","-06#"];   //x
            this.dataValueY_l = [];   //预警线

            for(let i in res){
              for(let j in res[i]){
                if(i == 0) {
                  this.dataValueY_l.push(res[i][j].warnValue)
                  // console.log(res[i][j].warnValue)
                }
                this.productData[[i]].push(res[i][j].value);
              }
            }

            // console.log(this.productData)

            //记得异步调用后端，要写进then里渲染
            //渲染echart
            this.loadChart()

          })



      this.loadChart()

    },
    loadChart(){
      this.option = {
        color: ['#339900','#2f89cf','#FF3300'],  //柱子颜色(调色盘)
        title: {
          text: this.echartTitle,
          // [title的位置]  left 的值可以是像 20 这样的具体像素值，可以是像 '20%' 这样相对于容器高宽的百分比，也可以是 'left', 'center', 'right'。
          //如果 left 的值为'left', 'center', 'right'，组件会根据相应的位置自动对齐。
          left:'left',
          textStyle:{
            //文字颜色
            color:'#FFFFFF',
            //字体风格,'normal','italic','oblique'
            fontStyle:'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight:'normal',
            //字体系列
            fontFamily:'微软雅黑',
            //字体大小
            fontSize:18,
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          // 当serise 有name值时， legend 不需要写data
          // 修改图例组件文字颜色
          textStyle: {
            color: '#4c9bfd'
          },
          right: '10%',
          // data: [{
          //   name: '南车',
          //   // 强制设置图形为圆。
          //   icon: 'circle',
          //   // 设置文本为红色
          //   textStyle: {
          //     color: 'red'
          //   }
          // }]
        },
        xAxis: [{
          type: 'category',
          data: this.dataValueX,
          // 修改刻度标签，相关样式
          axisLabel: {
            color: "rgba(255,255,255,0.8)",
            fontSize: 15
          },
          // x轴样式不显示
          axisLine: {
            show:false
          }
        }],
        // y轴相关配置
        yAxis: [{
          type: 'value',
          // 修改刻度标签，相关样式
          axisLabel: {
            color: "rgba(255,255,255,0.6)",
            fontSize: 12
          },
          // y轴样式修改
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.6)",
              width: 2
            }
          },
          // y轴分割线的颜色
          splitLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.1)"
            }
          }
        }],
        series: [
            {
              name: '北车',
              type: 'bar',
              barWidth: '35%',
              data: this.productData[0],
              itemStyle: {
                // 修改柱子圆角
                barBorderRadius: 5
              },
            },
            {
              name: '南车',
              type: 'bar',
              barWidth: '35%',
              data: this.productData[1],
              itemStyle: {
                // 修改柱子圆角
                barBorderRadius: 5
              },
            },
            {
              name: '预警线',
              type: 'line',
              showSymbol: false,        //去掉坐标点
              smooth: true,             // 圆滑的线
              data: this.dataValueY_l,

            }
        ]
      }
      this.chart = echarts.init(document.getElementById(this.id));
      this.chart.setOption(this.option)

      //echart浏览器自动缩放
      let myChart = this.chart;
      window.addEventListener('resize',()=>{
        myChart.resize();
      })
    }
  }
}
</script>

<style scoped>

</style>
